var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('Header',{ref:"header",attrs:{"is-open":_vm.isOpen,"date-picker":_vm.pickerInstance}}),_c('Picker',{ref:"picker",attrs:{"is-open":_vm.isOpen,"is-inline":_vm.isInline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }